import React, {useState} from "react";
import { InputsText } from "../../components/InputsText/index.js";
import { ArrowCircleBrokenDownRight1 } from "../../components/ArrowCircleBrokenDownRight1/index.js";
import { CursorBox1 } from "../../components/CursorBox1/index.js";
import { OutlineBusinessStatisticPresentationGraph1 } from "../../components/OutlineBusinessStatisticPresentationGraph1/index.js";
import { OutlineNotesArchiveUp1 } from "../../components/OutlineNotesArchiveUp1/index.js";
import { OutlineUsersUsersGroupTwoRounded1 } from "../../components/OutlineUsersUsersGroupTwoRounded1/index.js";
import { ShieldDollar1 } from "../../components/ShieldDollar1/index.js";
import { UserCheck011 } from "../../components/UserCheck011/index.js";
import "./style.css";
import { Footer } from "./Footer.js"
import { Navbar } from "./Navbar.js";

export const JybeBusinessPage = () => {
  const [clicked, setClicked] = useState(false)
  const [formData, setFormData] = useState({})

  const sendMail = () => {
    fetch(`https://testing.api.jybe.ca/sendMail`, {
      method: "POST",
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData
      })
  })
  }

  const handleChange = (name, newValue) => {
    setFormData((prevFormData) => ({ ...prevFormData, [name]: newValue }));
};

  return (
    <div className="jybe-business-page">
      <div className="frame-4">
        <div className="section">
          <div className="group-2">
            <div className="overlap-group-wrapper">
              <div className="overlap-group-2">
                <div className="group-3">
                  <div className="group-4">
                    <div className="rectangle-2" />
                    <div className="rectangle-3" />
                  </div>
                  <div className="group-5">
                    <div className="rectangle-4" />
                    <div className="rectangle-5" />
                  </div>
                  <div className="group-6">
                    <div className="rectangle-6" />
                    <div className="rectangle-7" />
                  </div>
                  <div className="group-7">
                    <div className="rectangle-8" />
                    <div className="rectangle-9" />
                  </div>
                  <div className="group-8">
                    <div className="rectangle-10" />
                    <div className="rectangle-11" />
                  </div>
                  <div className="group-9">
                    <div className="rectangle-12" />
                    <div className="rectangle-13" />
                  </div>
                  <div className="group-10">
                    <div className="rectangle-14" />
                    <div className="rectangle-15" />
                  </div>
                </div>
                <div className="text-wrapper-8">This Week</div>
                <div className="text-wrapper-9">Subscriptions</div>
              </div>
            </div>
            <div className="overlap-wrapper">
              <div className="overlap">
                <div className="text-wrapper-10">Overview</div>
                <div className="group-11">
                  <div className="text-wrapper-11">Subscribers</div>
                  <div className="text-wrapper-12">18,287</div>
                </div>
                <div className="group-12">
                  <div className="text-wrapper-11">ROI</div>
                  <div className="text-wrapper-13">+87%</div>
                </div>
              </div>
            </div>
          </div>
          <div className="frame-5">
            <div className="div-2">
              <div className="text-wrapper-14">Super Charge Your Subscriptions</div>
              <p className="p">
              Get more subscribers, streamline cashflow and reduce churn by offering Buy Now, Pay Later to your subscribers with Jybe.
              </p>
            </div>
            <button className="button-2">
              <a href="https://documentation.jybe.ca" target="_blank" className="text-6">Get Started</a>
            </button>
          </div>
          <img className="image" alt="Image" src="https://c.animaapp.com/AP7s1SnC/img/image-1.png" />
          <img className="image-2" alt="Image" src="https://c.animaapp.com/AP7s1SnC/img/image-1.png" />
        </div>
        <div className="section-2">
          <div className="frame-6">
            <p className="we-help-subscription">
              We Help <br />
              Subscription Business Thrive!
            </p>
            {/* <p className="text-wrapper-15">
              Lorem ipsum dolor sit amet consectetur. Sed ullamcorper nunc arcu ipsum at. Dictumst et quisque purus.
            </p> */}
          </div>
          <div className="frame-7">
            <div className="frame-8">
              <OutlineNotesArchiveUp1 className="icon-instance-node" />
              <div className="frame-9">
                <div className="text-wrapper-14">43%</div>
                <p className="text-wrapper-16">higher Adoption of Annual Subscriptions</p>
              </div>
            </div>
            <div className="frame-10">
              <OutlineUsersUsersGroupTwoRounded1 className="icon-instance-node" />
              <div className="frame-9">
                <div className="text-wrapper-14">19%</div>
                <div className="text-wrapper-16">Higher Subscription Count</div>
              </div>
            </div>
            <div className="frame-11">
              <OutlineBusinessStatisticPresentationGraph1 className="icon-instance-node" />
              <div className="frame-9">
                <div className="text-wrapper-14">100%</div>
                <div className="text-wrapper-16">Funds Paid Upfront</div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-3">
          {/* <div className="img-3">
            <div className="overlap-2">
              <div className="ellipse" />
              <div className="pyramid">
                <div className="overlap-group-3">
                  <img
                    className="pyramid-2"
                    alt="Pyramid"
                    src="https://c.animaapp.com/AP7s1SnC/img/pyramid-02-1-1@2x.png"
                  />
                  <img
                    className="mask-group"
                    alt="Mask group"
                    src="https://c.animaapp.com/AP7s1SnC/img/mask-group-1@2x.png"
                  />
                </div>
              </div>
              <div className="ellipse-2" />
              <div className="pyramid-3">
                <div className="overlap-3">
                  <img
                    className="pyramid-4"
                    alt="Pyramid"
                    src="https://c.animaapp.com/AP7s1SnC/img/pyramid-02-1-2@2x.png"
                  />
                  <img
                    className="mask-group-2"
                    alt="Mask group"
                    src="https://c.animaapp.com/AP7s1SnC/img/mask-group-2@2x.png"
                  />
                </div>
              </div>
              <div className="group-13">
                <div className="overlap-4">
                  <img className="body" alt="Body" src="https://c.animaapp.com/AP7s1SnC/img/body.png" />
                  <div className="group-14">
                    <div className="overlap-5">
                      <img
                        className="rectangle-16"
                        alt="Rectangle"
                        src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3407.svg"
                      />
                      <StatusBar
                        batteryClassName="status-bar-11"
                        charge="https://c.animaapp.com/AP7s1SnC/img/charge-1.svg"
                        chargeClassName="status-bar-13"
                        className="status-bar-instance"
                        divClassName="design-component-instance-node"
                        frameClassName="status-bar-3"
                        groupClassName="status-bar-4"
                        img="https://c.animaapp.com/AP7s1SnC/img/oval-1-copy-2-1.svg"
                        img1="https://c.animaapp.com/AP7s1SnC/img/--1.svg"
                        imgClassName="status-bar-14"
                        oval="https://c.animaapp.com/AP7s1SnC/img/oval-1-1.svg"
                        ovalClassName="status-bar-5"
                        ovalCopy="https://c.animaapp.com/AP7s1SnC/img/oval-1-copy-1.svg"
                        ovalCopyClassName="status-bar-6"
                        ovalCopyClassNameOverride="status-bar-7"
                        overlapGroupClassName="status-bar-12"
                        property1="default"
                        rectangleClassName="status-bar-2"
                        shape="https://c.animaapp.com/AP7s1SnC/img/shape-3.svg"
                        shape1="https://c.animaapp.com/AP7s1SnC/img/shape-4.svg"
                        shapeClassName="status-bar-8"
                        shapeClassNameOverride="status-bar-9"
                        wifi="https://c.animaapp.com/AP7s1SnC/img/wifi-1@2x.png"
                        wifiClassName="status-bar-10"
                      />
                      <img
                        className="rectangle-17"
                        alt="Rectangle"
                        src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3410.svg"
                      />
                      <div className="group-15">
                        <div className="group-16">
                          <OutlineEssentionalUiHamburgerMenu1 className="outline-essentional" color="#2983EE" />
                          <OutlineShoppingEcommerceBag4 className="outline-shopping" color="#2983EE" />
                          <OutlineSearchMagnifer className="outline-search" color="#2983EE" />
                          <div className="voritt-logo">
                            <img className="vector" alt="Vector" src="https://c.animaapp.com/AP7s1SnC/img/vector.svg" />
                            <img
                              className="vector-2"
                              alt="Vector"
                              src="https://c.animaapp.com/AP7s1SnC/img/vector-1.svg"
                            />
                            <img
                              className="vector-3"
                              alt="Vector"
                              src="https://c.animaapp.com/AP7s1SnC/img/vector-2.svg"
                            />
                            <img
                              className="vector-4"
                              alt="Vector"
                              src="https://c.animaapp.com/AP7s1SnC/img/vector-3.svg"
                            />
                            <img
                              className="vector-5"
                              alt="Vector"
                              src="https://c.animaapp.com/AP7s1SnC/img/vector-4.svg"
                            />
                            <img
                              className="vector-6"
                              alt="Vector"
                              src="https://c.animaapp.com/AP7s1SnC/img/vector-5.svg"
                            />
                            <div className="overlap-group-4">
                              <img
                                className="vector-7"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-6.svg"
                              />
                              <img
                                className="vector-8"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-7.svg"
                              />
                              <img
                                className="vector-9"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-8.svg"
                              />
                              <img
                                className="vector-10"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-9.svg"
                              />
                              <img
                                className="group-17"
                                alt="Group"
                                src="https://c.animaapp.com/AP7s1SnC/img/group-1@2x.png"
                              />
                              <img
                                className="group-17"
                                alt="Group"
                                src="https://c.animaapp.com/AP7s1SnC/img/group-1@2x.png"
                              />
                              <img
                                className="img-4"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-10.svg"
                              />
                              <img
                                className="img-4"
                                alt="Clip path group"
                                src="https://c.animaapp.com/AP7s1SnC/img/clip-path-group@2x.png"
                              />
                            </div>
                          </div>
                        </div>
                        <img
                          className="vector-11"
                          alt="Vector"
                          src="https://c.animaapp.com/AP7s1SnC/img/vector-101.svg"
                        />
                      </div>
                      <div className="frame-12">
                        <div className="frame-13">
                          <div className="toggle-radio">
                            <div className="rectangle-18" />
                          </div>
                          <div className="frame-14">
                            <div className="voritt-logo-2">
                              <img
                                className="vector-12"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-11.svg"
                              />
                              <img
                                className="vector-13"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-12.svg"
                              />
                              <img
                                className="vector-14"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-13.svg"
                              />
                              <img
                                className="vector-15"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-14.svg"
                              />
                              <img
                                className="vector-16"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-15.svg"
                              />
                              <img
                                className="vector-17"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-16.svg"
                              />
                              <div className="overlap-group-5">
                                <img
                                  className="vector-18"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-17.svg"
                                />
                                <img
                                  className="vector-19"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-18.svg"
                                />
                                <img
                                  className="vector-20"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-19.svg"
                                />
                                <img
                                  className="vector-21"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-20.svg"
                                />
                                <img
                                  className="group-18"
                                  alt="Group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/group-3@2x.png"
                                />
                                <img
                                  className="group-18"
                                  alt="Group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/group-3@2x.png"
                                />
                                <img
                                  className="img-5"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-21.svg"
                                />
                                <img
                                  className="img-5"
                                  alt="Clip path group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/clip-path-group-1@2x.png"
                                />
                              </div>
                            </div>
                            <div className="text-wrapper-17">Monthly</div>
                          </div>
                        </div>
                        <div className="frame-4">
                          <div className="frame-15">
                            <div className="text-wrapper-18">$38.99</div>
                            <div className="text-wrapper-19">/ mon</div>
                          </div>
                        </div>
                      </div>
                      <div className="text-wrapper-20">Payment Plans</div>
                      <div className="frame-16">
                        <div className="frame-13">
                          <div className="toggle-radio">
                            <div className="rectangle-18" />
                          </div>
                          <div className="frame-14">
                            <div className="voritt-logo-3">
                              <img
                                className="vector-22"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-22.svg"
                              />
                              <img
                                className="vector-23"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-23.svg"
                              />
                              <img
                                className="vector-24"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-24.svg"
                              />
                              <img
                                className="vector-25"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-25.svg"
                              />
                              <img
                                className="vector-26"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-26.svg"
                              />
                              <img
                                className="vector-27"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-27.svg"
                              />
                              <div className="overlap-group-6">
                                <img
                                  className="vector-28"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-28.svg"
                                />
                                <img
                                  className="vector-29"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-29.svg"
                                />
                                <img
                                  className="vector-30"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-30.svg"
                                />
                                <img
                                  className="vector-31"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-31.svg"
                                />
                                <img
                                  className="group-19"
                                  alt="Group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/group-5@2x.png"
                                />
                                <img
                                  className="group-19"
                                  alt="Group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/group-5@2x.png"
                                />
                                <img
                                  className="img-6"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-32.svg"
                                />
                                <img
                                  className="img-6"
                                  alt="Clip path group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/clip-path-group-2@2x.png"
                                />
                              </div>
                            </div>
                            <div className="text-wrapper-21">Yearly</div>
                          </div>
                        </div>
                        <div className="frame-4">
                          <div className="frame-15">
                            <div className="text-wrapper-18">$311.99</div>
                            <div className="text-wrapper-22">/ Year</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-17">
                        <div className="frame-13">
                          <div className="toggle-radio">
                            <div className="rectangle-19" />
                          </div>
                          <div className="frame-14">
                            <div className="voritt-logo-3">
                              <img
                                className="vector-22"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-33.svg"
                              />
                              <img
                                className="vector-23"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-34.svg"
                              />
                              <img
                                className="vector-24"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-35.svg"
                              />
                              <img
                                className="vector-25"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-36.svg"
                              />
                              <img
                                className="vector-26"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-37.svg"
                              />
                              <img
                                className="vector-27"
                                alt="Vector"
                                src="https://c.animaapp.com/AP7s1SnC/img/vector-38.svg"
                              />
                              <div className="overlap-group-6">
                                <img
                                  className="vector-28"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-39.svg"
                                />
                                <img
                                  className="vector-29"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-40.svg"
                                />
                                <img
                                  className="vector-30"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-41.svg"
                                />
                                <img
                                  className="vector-31"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-42.svg"
                                />
                                <img
                                  className="group-19"
                                  alt="Group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/group-7@2x.png"
                                />
                                <img
                                  className="group-19"
                                  alt="Group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/group-7@2x.png"
                                />
                                <img
                                  className="img-6"
                                  alt="Vector"
                                  src="https://c.animaapp.com/AP7s1SnC/img/vector-43.svg"
                                />
                                <img
                                  className="img-6"
                                  alt="Clip path group"
                                  src="https://c.animaapp.com/AP7s1SnC/img/clip-path-group-3@2x.png"
                                />
                              </div>
                            </div>
                            <div className="text-wrapper-23">Yearly (monthly payments)</div>
                          </div>
                        </div>
                        <div className="frame-18">
                          <div className="frame-15">
                            <div className="text-wrapper-24">$29.99</div>
                            <div className="text-wrapper-25">/ mon</div>
                          </div>
                          <img className="logo" alt="Logo" src="https://c.animaapp.com/AP7s1SnC/img/logo@2x.png" />
                        </div>
                      </div>
                      <div className="frame-wrapper">
                        <div className="frame-4">
                          <div className="frame-19">
                            <div className="text-wrapper-26">$29.99</div>
                            <BoldEssentionalUiCheckCircle1 className="bold-essentional-UI" />
                          </div>
                          <div className="frame-20">
                            <p className="text-wrapper-27">$311.99 in 12 monthly payment of</p>
                            <img
                              className="logo-2"
                              alt="Logo"
                              src="https://c.animaapp.com/AP7s1SnC/img/logo-1@2x.png"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <img src="/phone.png" style={{height:'100vh', width:'45vw'}} />
          <div className="frame-21">
            <div className="div-2">
              <div className="text-wrapper-28">How it Works</div>
            </div>
            <div className="div-box">
              <div className="text-wrapper-29">Step 1</div>
              <div className="div-2">
                <div className="text-wrapper-30">Easier Conversions</div>
                <p className="text-wrapper-31">
                Jybes payment flexibility increases the total number of annual subscriptions boosting customer retention and upfront capital.
                </p>
              </div>
            </div>
            <div className="div-box">
              <div className="text-wrapper-29">Step 2</div>
              <div className="div-2">
                <div className="text-wrapper-30">More Subscribers</div>
                <p className="text-wrapper-31">
                By offering your customers the option to split up payments, Jybe increases total subscriber count.
                </p>
              </div>
            </div>
            <div className="div-box">
              <div className="text-wrapper-29">Step 3</div>
              <div className="div-2">
                <div className="text-wrapper-30">Monthly Payment Options</div>
                <p className="text-wrapper-31">
                  Jybe offers your consumers regular monthly installments for you discounted annual subscription option.
                  Jybe pays your business upfront for the whole year and collects payments from the consumer.
                </p>
              </div>
            </div>
            <div className="div-box">
              <div className="text-wrapper-29">Step 4</div>
              <div className="div-2">
                <div className="text-wrapper-30">No Risk To You</div>
                <p className="text-wrapper-31">
                Jybe takes all risk of repayment, including fraud and chargebacks, and we pay you in full the next business day
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="frame-22">
          <img className="group-20" alt="Group" src="https://c.animaapp.com/AP7s1SnC/img/group-33795.png" />
          <div className="form">
            <div className="div-2">
              <div className="text-wrapper-28">Contact Us</div>
              <p className="text-wrapper-32">
                Contact us if you would like us integrated into your checkout!
              </p>
            </div>
            <div className="div-2">
              <div className="frame-23">
                <InputsText
                  className="inputs-text-instance"
                  focusClassName="design-component-instance-node-3"
                  frameClassName="design-component-instance-node-2"
                  state="default"
                  text="First Name"
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                <InputsText
                  className="inputs-text-instance"
                  focusClassName="design-component-instance-node-3"
                  frameClassName="design-component-instance-node-2"
                  state="default"
                  text="Last Name"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <InputsText
                className="design-component-instance-node-4"
                focusClassName="design-component-instance-node-3"
                frameClassName="design-component-instance-node-2"
                state="default"
                text="Business Email"
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <InputsText
                className="design-component-instance-node-4"
                focusClassName="design-component-instance-node-3"
                frameClassName="design-component-instance-node-2"
                state="default"
                text="Website"
                type="text"
                name="website"
                value={formData.website}
                onChange={handleChange}
              />
                            <InputsText
                className="design-component-instance-node-4"
                focusClassName="design-component-instance-node-3"
                frameClassName="design-component-instance-node-2"
                state="default"
                text="Country"
                type="text"
                name="Country"
                value={formData.country}
                onChange={handleChange}
              />
              {/* <SelectField
                className="design-component-instance-node-4"
                fieldClassName="design-component-instance-node-2"
                focusClassName="design-component-instance-node-3"
                frame="https://c.animaapp.com/AP7s1SnC/img/frame-123-6.svg"
                property1="default"
                text="Country"
                name="country"
                value={formData.country}
                onChange={handleChange}
              /> */}
              <InputsText
                className="design-component-instance-node-4"
                focusClassName="design-component-instance-node-3"
                frameClassName="design-component-instance-node-2"
                state="default"
                text="Integration Platform"
                type="text"
                name="integration"
                value={formData.integration}
                onChange={handleChange}
              />
              {/* <SelectField
                className="design-component-instance-node-4"
                fieldClassName="design-component-instance-node-2"
                focusClassName="design-component-instance-node-3"
                frame="https://c.animaapp.com/AP7s1SnC/img/frame-123-6.svg"
                property1="default"
                text="Integration Platform"
                name="integration"
                value={formData.integration}
                onChange={handleChange}
              /> */}
              <InputsText
                className="design-component-instance-node-4"
                focusClassName="design-component-instance-node-3"
                frameClassName="design-component-instance-node-2"
                state="default"
                text="Annual Revenue"
                type="text"
                name="AnnualRevenue"
                value={formData.AnnualRevenue}
                onChange={handleChange}
              />
              {/* <SelectField
                className="design-component-instance-node-4"
                fieldClassName="design-component-instance-node-2"
                focusClassName="design-component-instance-node-3"
                frame="https://c.animaapp.com/AP7s1SnC/img/frame-123-6.svg"
                property1="default"
                text="Annual Revenue"
                name="annualRevenue"
                value={formData.annualRevenue}
                onChange={handleChange}
              /> */}
              <InputsText
                className="design-component-instance-node-4"
                focusClassName="design-component-instance-node-3"
                frameClassName="design-component-instance-node-2"
                state="default"
                text="Average Order Value"
                type="text"
                name="averageOrderValue"
                value={formData.averageOrderValue}
                onChange={handleChange}
              />
              {/* <SelectField
                className="design-component-instance-node-4"
                fieldClassName="design-component-instance-node-2"
                focusClassName="design-component-instance-node-3"
                frame="https://c.animaapp.com/AP7s1SnC/img/frame-123-6.svg"
                property1="default"
                text="Average Order Value"
                name="annualRevenue"
                value={formData.annualRevenue}
                onChange={handleChange}
              /> */}
            </div>
            <div className="frame-24">
              <div className="rectangle-wrapper">
                <div className={`rectangle-20 ${clicked ? "filled" : ""}`} onClick={() => setClicked(!clicked) }>
                  {clicked &&
                  <svg style={{color: "white",
                  width: "10px",
                  marginLeft: "1.5px"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" fill="white"></path></svg>
                  }
                </div>
              </div>
              <p className="by-checking-ths-box">
                <span className="text-wrapper-33">
                  By checking ths box, i agree to receive emails, telephone calls, promotional offers and jybe
                </span>
                <a target="_blank" href="https://app.jybe.ca/privacy.pdf" className="text-wrapper-34"> terms &amp; conditions</a>
                <span className="text-wrapper-33"> and </span>
                <a target="_blank" href="https://app.jybe.ca/privacy.pdf" className="text-wrapper-34">privacy policy</a>
                <span className="text-wrapper-33">.</span>
              </p>
            </div>
            <button className="button-wrapper">
              <button onClick={clicked && sendMail} className="button-3">
                <div className="text-7">Send Message</div>
              </button>
            </button>
          </div>
          {/* <div className="img-7">
            <div className="overlap-group-7">
              <div className="group-21">
                <div className="group-22">
                  <img
                    className="rectangle-21"
                    alt="Rectangle"
                    src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3414@2x.png"
                  />
                  <img
                    className="rectangle-22"
                    alt="Rectangle"
                    src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3415@2x.png"
                  />
                </div>
                <div className="group-23">
                  <img
                    className="rectangle-21"
                    alt="Rectangle"
                    src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3414-1@2x.png"
                  />
                  <img
                    className="rectangle-23"
                    alt="Rectangle"
                    src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3415-1@2x.png"
                  />
                </div>
                <div className="group-24">
                  <img
                    className="rectangle-24"
                    alt="Rectangle"
                    src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3414-2@2x.png"
                  />
                  <img
                    className="rectangle-23"
                    alt="Rectangle"
                    src="https://c.animaapp.com/AP7s1SnC/img/rectangle-3415-2@2x.png"
                  />
                </div>
              </div>
              <img
                className="shutterstock"
                alt="Shutterstock"
                src="https://c.animaapp.com/AP7s1SnC/img/shutterstock-2159023891-1@2x.png"
              />
              <img
                className="pexels-rebrand"
                alt="Pexels rebrand"
                src="https://c.animaapp.com/AP7s1SnC/img/pexels-rebrand-cities-581004-1367276-1@2x.png"
              />
              <img
                className="pexels-rdne"
                alt="Pexels rdne"
                src="https://c.animaapp.com/AP7s1SnC/img/pexels-rdne-7413877-1@2x.png"
              />
              <img
                className="pexels-shvetsa"
                alt="Pexels shvetsa"
                src="https://c.animaapp.com/AP7s1SnC/img/pexels-shvetsa-5324985-1@2x.png"
              />
            </div>
          </div> */}
          <img src="/6ppl.png" style={{zIndex:10, height:'90vh'}} />
        </div>
        <div className="section-4">
          <div className="heading-wrapper">
            <div className="heading">
              <div className="text-wrapper-35">Integrations</div>
            </div>
          </div>
          {/* <div className="group-25">
            <div className="overlap-6">
              <img className="group-26" alt="Group" src="https://c.animaapp.com/AP7s1SnC/img/group-33790@2x.png" />
              <img className="group-27" alt="Group" src="https://c.animaapp.com/AP7s1SnC/img/group-33794@2x.png" />
              <div className="group-28">
                <div className="stripe-wrapper">
                  <Stripe className="stripe-2" />
                </div>
                <img className="logo-3" alt="Logo" src="https://c.animaapp.com/AP7s1SnC/img/logo-2.svg" />
                <img className="logo-4" alt="Logo" src="https://c.animaapp.com/AP7s1SnC/img/logo-3.svg" />
              </div>
              <img className="group-29" alt="Group" src="https://c.animaapp.com/AP7s1SnC/img/group-33789.png" />
              <div className="group-30">
                <div className="overlap-group-8">
                  <div className="rectangle-25" />
                  <div className="rectangle-26" />
                  <div className="rectangle-27" />
                  <div className="rectangle-28" />
                  <img className="logo-5" alt="Logo" src="https://c.animaapp.com/AP7s1SnC/img/logo-4.svg" />
                </div>
              </div>
            </div>
          </div> */}
          <img src="/integrations.png"/> 
        </div>
        <div className="section-4" style={{padding:'0vh 5vw'}} >
          <div className="headings">
            <div className="text-wrapper-35">No Risk. Just Benefits</div>
            <p className="text-wrapper-36">Jybe is proven to make running your business easier.</p>
          </div>
          <div className="frame-26">
            <div className="container">
              <div className="card">
                <CursorBox1 className="icon-instance-node-2" />
                <div className="section-heading">Get New Customers</div>
                <p className="section-heading-2">
                Jybes payment flexibility brings new subscribers through the door.
                </p>
              </div>
              <div className="card">
                <img
                  className="icon-instance-node-2"
                  alt="Arcticons secure box"
                  src="https://c.animaapp.com/AP7s1SnC/img/arcticons-secure-box.svg"
                />
                <div className="section-heading">Seller Protection</div>
                <p className="section-heading-2">
                  We assume all credit & fraud risk when our payment methods are used, so you can just focus on your business.
                </p>
              </div>
            </div>
            <div className="container">
              <div className="card">
                <ArrowCircleBrokenDownRight1 className="icon-instance-node-2" />
                <div className="section-heading">Zero Fraud Liability</div>
                <p className="section-heading-2">
                Jybe takes full responsibility for fraud and subscription payments.
                </p>
              </div>
              <div className="card">
                <ShieldDollar1 className="icon-instance-node-2" />
                <div className="section-heading">Upfront Payments</div>
                <p className="section-heading-2">
                  Retailers are always paid in full with any Jybe payment method.
                </p>
              </div>
              <div className="card">
                <UserCheck011 className="icon-instance-node-2" />
                <div className="section-heading">Problem? No Problem</div>
                <p className="section-heading-2">
                  We're here to help if anything unexpected happens during the subscription journey
                </p>
              </div>
            </div>
          </div>
          <button className="button-3">
            <a href="https://documentation.jybe.ca" target="_blank" className="text-6">Get Started</a>
          </button>
        </div>
        {/* <div className="section-4">
          <div className="div-3">
            <div className="heading">
              <div className="text-wrapper-35">Who We Work With</div>
            </div>
          </div>
          <p className="text-wrapper-37">Jybe is proven to make running your business easier.</p>
          <div className="frame-27">
            <div className="frame-28">
              <Stripe className="stripe-2" />
              <img
                className="salesforce-com-logo"
                alt="Salesforce com logo"
                src="https://c.animaapp.com/AP7s1SnC/img/salesforce-com-logo-1.svg"
              />
              <img className="magento" alt="Magento" src="https://c.animaapp.com/AP7s1SnC/img/magento.svg" />
              <img
                className="bc-logo-dark"
                alt="Bc logo dark"
                src="https://c.animaapp.com/AP7s1SnC/img/bc-logo-dark.svg"
              />
            </div>
            <div className="frame-29">
              <Stripe className="stripe-2" />
              <img
                className="salesforce-com-logo"
                alt="Salesforce com logo"
                src="https://c.animaapp.com/AP7s1SnC/img/salesforce-com-logo-1-1.svg"
              />
              <img
                className="shopify-logo"
                alt="Shopify logo"
                src="https://c.animaapp.com/AP7s1SnC/img/shopify-logo-2018.svg"
              />
              <img
                className="adyen-corporate-logo"
                alt="Adyen corporate logo"
                src="https://c.animaapp.com/AP7s1SnC/img/adyen-corporate-logo.svg"
              />
              <img className="magento" alt="Magento" src="https://c.animaapp.com/AP7s1SnC/img/magento-1.svg" />
              <img
                className="bc-logo-dark"
                alt="Bc logo dark"
                src="https://c.animaapp.com/AP7s1SnC/img/bc-logo-dark-1.svg"
              />
            </div>
          </div>
        </div> */}
      </div>
      {/* <footer className="footer">
        <div className="group-31">
          <div className="overlap-7">
            <div className="pyramid-5">
              <div className="overlap-group-9">
                <img className="pyramid-6" alt="Pyramid" src="https://c.animaapp.com/AP7s1SnC/img/pyramid-02-1-3.png" />
                <img
                  className="mask-group-3"
                  alt="Mask group"
                  src="https://c.animaapp.com/AP7s1SnC/img/mask-group-3.png"
                />
              </div>
            </div>
            <div className="pyramid-7">
              <div className="overlap-8">
                <img className="pyramid-8" alt="Pyramid" src="https://c.animaapp.com/AP7s1SnC/img/pyramid-02-1-4.png" />
                <img
                  className="mask-group-4"
                  alt="Mask group"
                  src="https://c.animaapp.com/AP7s1SnC/img/mask-group-4.png"
                />
              </div>
            </div>
            <div className="pyramid-9">
              <div className="overlap-9">
                <img
                  className="pyramid-10"
                  alt="Pyramid"
                  src="https://c.animaapp.com/AP7s1SnC/img/pyramid-02-1-5.png"
                />
                <img
                  className="mask-group-5"
                  alt="Mask group"
                  src="https://c.animaapp.com/AP7s1SnC/img/mask-group-5.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="div-relative">
          <div className="div-relative-2">
            <div className="heading-2">
              <div className="text-wrapper-35">Save On Subscriptions</div>
              <p className="text-wrapper-38">
                Jybe is a BNPL service that helps consumer access their digital subscriptions for the cheapest possible
                monthly price!
              </p>
            </div>
            <button className="button-3">
              <div className="text-7">Contact Us</div>
            </button>
          </div>
          <div className="div-relative-3">
            <div className="div-grid">
              <div className="div-wforest-full">
                <div className="nav">
                  <div className="link-margin">
                    <div className="text-wrapper-39">About</div>
                  </div>
                  <div className="link-start-with-wrapper">
                    <div className="text-wrapper-39">Start With Jybe</div>
                  </div>
                  <div className="link-sign-in-wrapper">
                    <div className="text-wrapper-39">Sign In</div>
                  </div>
                  <div className="link-contact-wrapper">
                    <div className="text-wrapper-39">Contact</div>
                  </div>
                </div>
              </div>
              <div className="div-wforest-full">
                <div className="nav">
                  <div className="link-pricing-wrapper">
                    <div className="text-wrapper-39">Pricing</div>
                  </div>
                  <div className="link-blog-wrapper">
                    <div className="text-wrapper-39">Blog</div>
                  </div>
                  <div className="link-glossary-wrapper">
                    <div className="text-wrapper-39">Glossary</div>
                  </div>
                  <div className="link-careers-wrapper">
                    <div className="text-wrapper-39">Careers</div>
                  </div>
                </div>
              </div>
              <div className="nav-wrapper">
                <div className="nav">
                  <div className="link-wrapper">
                    <div className="link">
                      <img className="SVG" alt="Svg" src="https://c.animaapp.com/AP7s1SnC/img/svg.svg" />
                      <div className="text-wrapper-39">LinkedIn</div>
                    </div>
                  </div>
                  <div className="link-margin-2">
                    <div className="link-2">
                      <img className="SVG" alt="Svg" src="https://c.animaapp.com/AP7s1SnC/img/svg-1.svg" />
                      <div className="text-wrapper-39">Twitter</div>
                    </div>
                  </div>
                  <div className="link-margin-2">
                    <div className="link-3">
                      <img className="SVG" alt="Svg" src="https://c.animaapp.com/AP7s1SnC/img/svg-2.svg" />
                      <div className="text-wrapper-39">Instagram</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="div-wforest-full-2">
                <div className="nav-2">
                  <div className="terms-conditions-wrapper">
                    <div className="text-wrapper-39">Terms &amp; Conditions</div>
                  </div>
                  <div className="link-4">
                    <div className="text-wrapper-39">Privacy Policy</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="div-mt">
              <img className="logo-6" alt="Logo" src="https://c.animaapp.com/AP7s1SnC/img/logo-5@2x.png" />
              <div className="p-t">
                <div className="text-wrapper-40">© 2023 jybe, Inc</div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="navbar">
        <div className="frame-30">
          <img className="logo-7" alt="Logo" src="https://c.animaapp.com/AP7s1SnC/img/logo-6.svg" />
          <div className="frame-31">
            <TextTabItem
              className="design-component-instance-node-5"
              divClassName="design-component-instance-node-6"
              iconLeft={false}
              iconRight={false}
              property1="default"
              text="Home"
            />
            <TextTabItem
              className="design-component-instance-node-5"
              divClassNameOverride="design-component-instance-node-6"
              iconLeft={false}
              iconRight={false}
              property1="inactive"
              text1="About"
            />
            <TextTabItem
              className="design-component-instance-node-5"
              divClassNameOverride="design-component-instance-node-6"
              iconLeft={false}
              iconRight={false}
              property1="inactive"
              text1="Start Jybing"
            />
            <TextTabItem
              className="design-component-instance-node-5"
              divClassNameOverride="design-component-instance-node-6"
              iconLeft={false}
              iconRight={false}
              property1="inactive"
              text1="Contact"
            />
          </div>
          <Button
            className="design-component-instance-node-5"
            icon="false"
            size="lg"
            state="default"
            text="Contact Us"
            textClassName="design-component-instance-node-6"
            type="primary"
          />
        </div>
      </div> */}
      <Footer />
      <Navbar
          className="navbar-instance"
        />
      {/* <img
        className="pexels-ketut"
        alt="Pexels ketut"
        src="https://c.animaapp.com/AP7s1SnC/img/pexels-ketut-subiyanto-4473398-1@2x.png"
      /> */}
    </div>
  );
};
